angular.module('unica_tutorial.tutorial_services')

.factory('TutorialListService', function ($http, getBaseApiURL) {

	var tutorialService = {};

	tutorialService.list = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/tutorial/list',
			data: {
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.tutorials;
			}

		});

	};

	tutorialService.preview = function ( filename ) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/tutorial/preview',
			data: {
				filename
			}
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});

	};


	tutorialService.download = function ( id )
	{
		window.open(getBaseApiURL + '/tutorial/download/' + id);
	};

	return tutorialService;

});